/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * BfEventOrigin : Who asserts an event exists. Orthogonal to class (severity) and classification (hazard type); derived from the source process, never stored.
 */

export const BfEventOrigin = {
    agency: 'agency',
    automated: 'automated',
    predicted: 'predicted'
} as const;

export type BfEventOrigin = typeof BfEventOrigin[keyof typeof BfEventOrigin];



